import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,

  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,

  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,

  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
} from "../actions/types";

const initialState = {
  products: [],
  loading: false,
  error: null,
  message: "",
  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {

    case FETCH_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        message: "Products loaded successfully",
      };

    case FETCH_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: [action.payload, ...state.products],
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
        },
        message: "Product created successfully",
      };

    case CREATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.map((p) =>
          p.product_id === action.payload.product_id
            ? { ...p, ...action.payload }
            : p
        ),
        message: "Product updated successfully",
      };

    case UPDATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.filter(
          (p) => p.product_id !== action.payload
        ),
        pagination: {
          ...state.pagination,
          total:
            state.pagination.total > 0
              ? state.pagination.total - 1
              : 0,
        },
        message: "Product deleted successfully",
      };

    case DELETE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}